import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=227cef41&scoped=true&"
import script from "./SettingModal.vue?vue&type=script&lang=js&"
export * from "./SettingModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingModal.vue?vue&type=style&index=0&id=227cef41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227cef41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227cef41')) {
      api.createRecord('227cef41', component.options)
    } else {
      api.reload('227cef41', component.options)
    }
    module.hot.accept("./SettingModal.vue?vue&type=template&id=227cef41&scoped=true&", function () {
      api.rerender('227cef41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Group/SettingModal.vue"
export default component.exports